import { LoanAppTask } from './index';

export class UploadDocumentModel {
  dropZoneMessage?: string;
  id?: LoanAppTask.RequestedUploadedDocumentTypesEnum;
  label?: string;
  shouldShowDropZone?: boolean;
  task?: LoanAppTask;
}
